export default __webpack_public_path__ + "static/media/Spin-1s-200px.10ca842f.gif";